import Text from '../BuildingBlocks/Text';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

/**
 * A component for rendering an error message at the bottom of a form.
 *
 * This is for backend errors or erros that span multiple fields and we
 * can't just apply an error to a specific input.
 *
 * We never got design for these types of errors so this component could
 * use a little work.
 *
 * At some point it could handle multiple errors.
 */
export default class FormError extends Component {
  static propTypes = {
    message: PropTypes.string
  };

  static defaultProps = {
    message: undefined
  };

  render() {
    const { message } = this.props;

    if (!message) {
      return null;
    }

    return (
      <ul role="alert">
        <Text.CopyParagraph tagName="li" color="error">
          {message}
        </Text.CopyParagraph>
      </ul>
    );
  }
}
